import { defineMessages } from 'react-intl';

const messages = defineMessages({
  saveView: {
    description: 'filterView.saveFilterView',
    defaultMessage: 'Custom View - Click to Save',
    id: 'Dtp+m9',
  },
  filterViewAll: {
    description: 'filterView.All',
    defaultMessage: 'All',
    id: 'CQH3oV',
  },
  customView: {
    description: 'filterView.customView',
    defaultMessage: 'Custom View',
    id: 'q6MiKA',
  },
});

export default messages;
